angular.module('TetherApp').directive('tetherTextarea', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherTextarea.html'
    }
});
